import { handleResponse, handleError, ajax } from "../utils/Api";

export const sendEvent = async (page, event, msg, info, level) => {
  const levelParam = level ? `?level=${level}` : '';
  return ajax
    .post(`/telco/analytics${levelParam}`, {page: page, event: event, msg, info},  {headers: {withCredentials: true, 'X-API-KEY': 'AIzaSyClzfrOzB818x55FASHvX4JuGQciR9lv7q'}})
    .then(handleResponse)
    .catch(handleError);
}